// import React, { useEffect, useRef } from "react";
// import * as d3 from "d3";

// const ColorBar = ({ height = 50, min = 0, max = 100, colorRange }) => {
//     const svgRef = useRef();

//     useEffect(() => {
//         const svg = d3.select(svgRef.current);
//         svg.selectAll("*").remove();

//         // Get the parent container's width and set 80% of it as the width
//         const containerWidth = svgRef.current.parentElement.clientWidth * 0.8;
//         const margin = { left: 40, right: 50, top: 0, bottom: 20 };
//         const barWidth = containerWidth - margin.left - margin.right;
//         const barHeight = height - margin.top - margin.bottom;

//         const colorScale = d3.scaleLinear()
//             .domain([min, max])
//             .range(colorRange);

//         const defs = svg.append("defs");
//         const gradient = defs.append("linearGradient")
//             .attr("id", "colorGradient")
//             .attr("x1", "0%")
//             .attr("x2", "100%")
//             .attr("y1", "0%")
//             .attr("y2", "0%");

//         gradient.append("stop")
//             .attr("offset", "0%")
//             .attr("stop-color", colorScale(min));
//         gradient.append("stop")
//             .attr("offset", "100%")
//             .attr("stop-color", colorScale(max));

//         svg.append("rect")
//             .attr("x", margin.left)
//             .attr("y", margin.top)
//             .attr("width", barWidth)
//             .attr("height", barHeight)
//             .style("fill", "url(#colorGradient)");

//         const xScale = d3.scaleLinear()
//             .domain([min, max])
//             .range([margin.left, margin.left + barWidth]);

//         // Only show the first and last tick
//         const tickValues = [min, max];

//         const xAxis = d3.axisBottom(xScale)
//             .tickValues(tickValues)
//             .tickSize(2)
//             .tickFormat(d => Number.isInteger(d) ? d : d.toFixed(4).replace(/\.0+$/, ""));

//         svg.append("g")
//             .attr("transform", `translate(0, ${height - margin.bottom})`)
//             .call(xAxis);
//     }, [height, min, max]);

//     return <svg ref={svgRef} width="80%" height={height} style={{ display: "block", margin: "auto" }}></svg>;
// };

// export default ColorBar;


import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

const ColorBar = ({ height = 50, min = 0, max = 100, colorRange }) => {
    const svgRef = useRef();

    useEffect(() => {
        const svg = d3.select(svgRef.current);
        svg.selectAll("*").remove();

        const containerWidth = svgRef.current.parentElement.clientWidth * 0.8;
        const margin = { left: 40, right: 50, top: 0, bottom: 20 };
        const barWidth = containerWidth - margin.left - margin.right;
        const barHeight = height - margin.top - margin.bottom;

        const colorScale = d3.scaleLinear()
            .domain([min, (min + max) / 2, max])  // Three stops: Green → Yellow → Red
            .range(colorRange);

        const defs = svg.append("defs");
        const gradient = defs.append("linearGradient")
            .attr("id", "colorGradient")
            .attr("x1", "0%")
            .attr("x2", "100%")
            .attr("y1", "0%")
            .attr("y2", "0%");

        gradient.append("stop")
            .attr("offset", "0%")
            .attr("stop-color", colorScale(min));

        gradient.append("stop")
            .attr("offset", "50%")
            .attr("stop-color", colorScale((min + max) / 2));

        gradient.append("stop")
            .attr("offset", "100%")
            .attr("stop-color", colorScale(max));

        svg.append("rect")
            .attr("x", margin.left)
            .attr("y", margin.top)
            .attr("width", barWidth)
            .attr("height", barHeight)
            .style("fill", "url(#colorGradient)");

        const xScale = d3.scaleLinear()
            .domain([min, max])
            .range([margin.left, margin.left + barWidth]);

        const tickValues = [min, max];

        const xAxis = d3.axisBottom(xScale)
            .tickValues(tickValues)
            .tickSize(2)
            .tickFormat(d => Number.isInteger(d) ? d : d.toFixed(4).replace(/\.0+$/, ""));

        svg.append("g")
            .attr("transform", `translate(0, ${height - margin.bottom})`)
            .call(xAxis);
    }, [height, min, max, colorRange]);

    return <svg ref={svgRef} width="80%" height={height} style={{ display: "block", margin: "auto" }}></svg>;
};

export default ColorBar;